import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, Observable, take } from 'rxjs';
import { ButtonTypeAttributeEnum } from '@hrra/ui';
import { ButtonTypeEnum } from '@hrra/ui';
import { activateJobseekerPasswordChanges, cancelJobseekerPasswordChanges, changeJobseekerPassword } from 'src/app/root-store/jobseeker-store/jobseeker-settings/actions';
import { selectIsEmailChangeActive, selectIsPasswordChangeActive, selectJobseekerCurrentPasswordIsIncorrect, selectJobseekerPasswordMismatch } from 'src/app/root-store/jobseeker-store/jobseeker-settings/selectors';
import { AppState } from 'src/app/root-store/state';
import { JobseekerChangePasswordViewModel } from '../shared/services/jobseeker-settings.service';
import { selectJobseekerPasswordRequirements } from 'src/app/root-store/jobseeker-store/jobseeker-profile/selectors';

@Component({
    selector: 'app-jobseeker-settings-change-password',
    templateUrl: './jobseeker-settings-change-password.component.html',
    styleUrls: ['./jobseeker-settings-change-password.component.scss'],
    standalone: false
})
export class JobseekerSettingsChangePasswordComponent implements OnInit, OnDestroy {
  
  editForm: UntypedFormGroup;

  isCurrentPasswordIncorrect$: Observable<boolean>;
  jobseekerPasswordMismatch$: Observable<boolean>;

  isPasswordChangeActive$: Observable<boolean>;
  isEmailChangeActive$: Observable<boolean>;

  public buttonType: any;
  public buttonAttributeType: any;

  public passwordMinLength: number

  constructor(private fb: UntypedFormBuilder, private store: Store<AppState>) { 
    this.buttonType = ButtonTypeEnum;
    this.buttonAttributeType = ButtonTypeAttributeEnum;

    this.editForm = this.fb.group({
      currentPass: new UntypedFormControl(null, [Validators.required]),
      newPass: new UntypedFormControl(null),
      repeatPass: new UntypedFormControl(null, [Validators.required])
    }, { validator: this.customValidator})
  }

  customValidator(group : UntypedFormGroup) : {[s:string ]: boolean} {
    if (group){
      let newPass = group.controls['newPass'].value;
      let repeatPass = group.controls['repeatPass'].value;

      if(newPass != null && repeatPass != null && newPass != repeatPass) {
        return {'PasswordMismatch': true};
      }
    }
    return null;
  }

  onChangePassword(): void {
    this.store.dispatch(activateJobseekerPasswordChanges());
  }

  ngOnInit(): void {
    this.isCurrentPasswordIncorrect$ = this.store.pipe(select(selectJobseekerCurrentPasswordIsIncorrect));
    this.jobseekerPasswordMismatch$ = this.store.pipe(select(selectJobseekerPasswordMismatch));

    this.isPasswordChangeActive$ = this.store.select(selectIsPasswordChangeActive);
    this.isEmailChangeActive$ = this.store.select(selectIsEmailChangeActive);

    this.store.select(selectJobseekerPasswordRequirements).pipe(
      filter(val => val?.passwordMinLength !== undefined),
      take(1)
    )
    .subscribe((c) => {
        this.passwordMinLength = c.passwordMinLength
        this.editForm
        .get('newPass')
        .setValidators([
          Validators.minLength(c.passwordMinLength), 
          Validators.pattern(new RegExp(c.passwordRegexPattern)), 
          Validators.required
        ]);
    }
      
    )
  }

  onCancel(){
    this.editForm.get('currentPass').reset();
    this.editForm.get('newPass').reset();
    this.editForm.get('repeatPass').reset();

    this.store.dispatch(cancelJobseekerPasswordChanges());
  }

  onSave(){
    if(this.editForm.valid){
      var value = this.editForm.value

      let updateData = <JobseekerChangePasswordViewModel>{
        currentPassword: value.currentPass,
        newPassword: value.newPass,
        repeatNewPassword: value.repeatPass
      }

      this.store.dispatch(changeJobseekerPassword({payload: updateData}));

      this.editForm.get('currentPass').reset();
      this.editForm.get('newPass').reset();
      this.editForm.get('repeatPass').reset();
      
    }
  }

  ngOnDestroy() {
    this.editForm.get('currentPass').reset();
    this.editForm.get('newPass').reset();
    this.editForm.get('repeatPass').reset();

    this.store.dispatch(cancelJobseekerPasswordChanges());
  }
}
